import { RatingConfig } from "../models";
import rawConfig from "virtual:config";
import { RatingConfigSchema } from "../schemas/config.schema";

const validated = RatingConfigSchema.parse(rawConfig);

export const APP_CONFIG: RatingConfig = validated;
